/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { useLocation } from 'react-router';
import { useSelector, shallowEqual } from 'react-redux';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers';

export function AsideMenuList({ layoutProps }) {
	const location = useLocation();
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url)
			? ` ${!hasSubmenu &&
					'menu-item-active'} menu-item-open menu-item-not-hightlighted`
			: '';
	};
	const { roles } = useSelector(
		({ auth }) => ({
			roles: auth.user.roles,
		}),
		shallowEqual
	);

	let filterRole = roles.find(e => e === 1);

	return (
		<>
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				<li
					className={`menu-item ${getMenuItemActive('/pos/bills')}`}
					aria-haspopup='true'>
					<NavLink className='menu-link' to='/pos/bills'>
						<span className='svg-icon menu-icon'>
							<SVG
								src={toAbsoluteUrl('/media/svg/icons/Shopping/Dollar.svg')}
							/>
						</span>
						<span className='menu-text'>Hóa đơn</span>
					</NavLink>
				</li>
				{filterRole === 1 ? (
					<li
						className={`menu-item ${getMenuItemActive('/pos/guests')}`}
						aria-haspopup='true'>
						<NavLink className='menu-link' to='/pos/guests'>
							<span className='svg-icon menu-icon'>
								<SVG
									src={toAbsoluteUrl('/media/svg/icons/General/User.svg')}
								/>
							</span>
							<span className='menu-text'>Khách hàng</span>
						</NavLink>
					</li>
				) : (
					''
				)}
				{filterRole === 1 ? (
					<li
						className={`menu-item ${getMenuItemActive('/pos/transactions')}`}
						aria-haspopup='true'>
						<NavLink className='menu-link' to='/pos/transactions'>
							<span className='svg-icon menu-icon'>
								<SVG
									src={toAbsoluteUrl('/media/svg/icons/Shopping/Chart-bar1.svg')}
								/>
							</span>
							<span className='menu-text'>Giao dịch</span>
						</NavLink>
					</li>
				) : (
					''
				)}
				{filterRole === 1 ? (
					<li
						className={`menu-item ${getMenuItemActive('/pos/sync-history')}`}
						aria-haspopup='true'>
						<NavLink className='menu-link' to='/pos/sync-history'>
							<span className='svg-icon menu-icon'>
								<SVG
									src={toAbsoluteUrl('/media/svg/icons/Code/Time-schedule.svg')}
								/>
							</span>
							<span className='menu-text'>Lịch sử đồng bộ iPOS</span>
						</NavLink>
					</li>
				) : (
					''
				)}
			</ul>
		</>
	);
}
